module.exports = __webpack_public_path__ + "img/5cirMus.8297c793.png";